import { render, staticRenderFns } from "./BroadcastManager.vue?vue&type=template&id=0f8c4db8&"
import script from "./BroadcastManager.vue?vue&type=script&lang=ts&"
export * from "./BroadcastManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports